<template>
  <el-tag
    :type="getTagType"
    :effect="effect || 'light'"
    :size="size || 'default'"
    class="interview-status-tag"
  >
    {{ getStatusText }}
  </el-tag>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  status?: string | null;
  effect?: 'plain' | 'light' | 'dark';
  size?: 'large' | 'default' | 'small';
}>();

// 获取标签类型
const getTagType = computed(() => {
  if (!props.status) return 'info';
  
  switch (props.status) {
    case 'scheduled':
      return 'warning';
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'danger';
    case 'rescheduled':
      return 'warning';
    case 'in_progress':
      return 'primary';
    case 'not_scheduled':
    default:
      return 'info';
  }
});

// 获取状态文本
const getStatusText = computed(() => {
  if (!props.status) return '未设置';
  
  const statusMap: Record<string, string> = {
    'not_scheduled': '未安排',
    'scheduled': '已安排',
    'completed': '已完成',
    'cancelled': '已取消',
    'rescheduled': '已改期',
    'in_progress': '进行中'
  };
  
  return statusMap[props.status] || props.status;
});
</script>

<style scoped>
.interview-status-tag {
  border-radius: 4px;
  padding: 0 6px;
  font-size: 12px;
}
</style> 